import { render, staticRenderFns } from "./SettingSectionAction.vue?vue&type=template&id=0a74a5d1&scoped=true&"
import script from "./SettingSectionAction.vue?vue&type=script&lang=js&"
export * from "./SettingSectionAction.vue?vue&type=script&lang=js&"
import style0 from "./SettingSectionAction.vue?vue&type=style&index=0&id=0a74a5d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74a5d1",
  null
  
)

export default component.exports